import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { warningAlertSwitchSetting } from 'redux/action/warningAlert';
import alertSound from 'static/sound/warning-buzzer.mp3';
import useAudio from './useAudio';

const Alert = () => {
  const dispatch = useDispatch();
  const alertStatus = useSelector((state) => state.warningAlert.status); // 경고알람 데이터
  const alertSwitchStatus = useSelector((state) => state.warningAlert.switch); // 경고알람 데이터
  const [playing, toggle] = useAudio(alertSound);

  useEffect(() => {
    if (alertSwitchStatus === undefined) {
      dispatch(warningAlertSwitchSetting());
    }
  }, []);

  useEffect(() => {
    if (alertSwitchStatus && !playing && alertStatus) {
      toggle(true);
      window.localStorage.setItem('applicationStatus', '{ "alarm": "1", "status": "blue" }');
    } else if ((playing && !alertStatus) || !alertSwitchStatus) {
      toggle(false);
      window.localStorage.setItem('applicationStatus', '{ "alarm": "0", "status": "blue" }');
    }
  }, [alertStatus, alertSwitchStatus]);

  return <div></div>;
};

export default Alert;
